export default __webpack_public_path__ + "static/media/023-syringe.5293c303.svg";